module.exports = __webpack_public_path__ + "img/right.9b220c32.png";